import BigNumber from 'bignumber.js';

export const TRADE_PAGE_BODY_ID = 'trade-page-body';
export const MIN_COLLATERAL_USD = new BigNumber(10);

export enum TABS {
  Position = 'position',
  Order = 'order',
  DecreaseOrder = 'decrease-order',
  History = 'history',
}
